import React from "react";
import { AdMode } from "./AdTypes";

type AdContext = {
	currentTime?: number;
	headingId: string;
	linkId?: string;
	mode: AdMode;
	onClick?: (ev: React.MouseEvent) => void;
	target?: string;
	url?: string;
};

const AdContext = React.createContext<AdContext | undefined>(void 0);

type AdContextProviderProps = Omit<AdContext, "mode"> & {
	children: React.ReactNode;
	mode?: AdMode;
};

export function AdContextProvider(props: AdContextProviderProps) {
	const { children, currentTime, headingId, linkId, mode = "responsive", onClick, target, url } = props;

	const value = React.useMemo<AdContext>(
		() => ({
			currentTime,
			headingId,
			linkId,
			mode,
			onClick,
			target,
			url,
		}),
		[currentTime, headingId, linkId, mode, onClick, target, url],
	);

	return <AdContext.Provider value={value}>{children}</AdContext.Provider>;
}

export function useAdContext() {
	const context = React.useContext(AdContext);
	if (typeof context === "undefined") {
		throw new Error("useAdContext must be used within a AdContextProvider");
	}
	return context;
}
